import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { SidebarText, BodyText, Image, Quote, TwoColumnBlock, RegisterBar, LinkedPages } from '../slices'



const SliceZone = ({ allSlices }) => {
  if (!allSlices) return null

  const slice = allSlices.map(s => {
    switch (s.slice_type) {
      case 'text':
        return <BodyText key={s.id} input={s} />
      case 'text_block':
        return <SidebarText key={s.id} input={s} />
      case 'two_column_text':
        return <TwoColumnBlock key={s.id} input={s} />
      case 'image':
        return <Image key={s.id} input={s} />
      case 'quote':
        return <Quote key={s.id} input={s} />
      case 'register_bar':
        return <RegisterBar key={s.id} input={s} />
      case 'linked_pages':
        return <LinkedPages key={s.id} input={s} />
      default:
        return null
    }
  })
  return <div>{slice}</div>
}

export default SliceZone

SliceZone.propTypes = {
  allSlices: PropTypes.array,
}

SliceZone.defaultProps = {
  allSlices: [],
}
